<template>
	<v-dialog max-width="500px" v-model="isOpen" persistent>
		<v-form :disabled="!isEditable">
			<v-card class="pa-4">
				<v-row>
					<v-col md="12">
						<h1 class="pl-md-1 font-weight-light primary--text">
							Nota
						</h1>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12" cols="12">
						<v-card elevation="0" class="px-md-4">
							<!-- <v-row>
								<v-col md="12" class="mt-md-1">
									<h4 class="font-weight-light primary--text">
										Comercial
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-combobox
										clearable
										chips
										hide-selected
										:items="comerciales"
										item-value="id"
										:return-object="false"
										item-text="nombreCompleto"
										v-model="form.comercial"
										label="Comercial"
									>
										<template #item="{ item }">
											<v-row>
												<v-col cols="8">
													{{ item.nombreCompleto }}
												</v-col>
												<v-col
													v-if="item.estado"
													cols="4"
												>
													<v-chip
														label
														:color="
															estadoComercial[
																item.estado
															]
														"
														medium
														class="
															d-flex
															justify-center
															overline
														"
													>
														{{ item.estado }}
													</v-chip>
												</v-col>
											</v-row>
										</template>
										<template #selection="{ item }">
											<v-chip
												:color="
													!isEditable
														? 'primary lighten-3'
														: 'primary'
												"
												class="white--text"
											>
												<v-icon left size="20">
													mdi-account-circle-outline
												</v-icon>
												{{
													!isEditable
														? form.comercial
														: getComercialNombreFromId(
																item
														  )
												}}
											</v-chip>
										</template>
									</v-combobox>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12" cols="12">
						<v-card elevation="0" class="px-md-4">
							<!-- <v-row>
								<v-col md="12" class="mb-md-1 mt-md-1">
									<h4 class="font-weight-light primary--text">
										Notas
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-textarea
										append-icon="mdi-comment"
										class="mx-2"
										label="Comentarios"
										auto-grow
										v-model="form.nota"
									></v-textarea>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-card-actions class="justify-end mb-md-n4">
					<v-btn color="primary" depressed v-if="isEditable" @click="save">
						Guardar
					</v-btn>
					<v-btn text color="red" @click="closeForm()">
						Cerrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import defaultNotasForm from '@/util/atenciones/defaultNotasForm';

export default {
	name: 'NotasForm',
	data: () => ({
		estadoComercial: {
			ALTA: 'success',
			BAJA: 'warning',
			INACTIVO: 'error',
			VACACIONES: 'blue',
		},
	}),
	computed: {
		isOpen: {
			get() {
				return this.$store.state.teletrabajo.NotasForm['isOpen'];
			},
			set(val) {
				this.clearFields();
				this.$store.state.teletrabajo.NotasForm['isOpen'] = val;
			},
		},
		...mapState('teletrabajo', {
			comerciales: (state) => state.Comerciales,
			form: (state) => state.NotasForm.form,
			isEditable: (state) => state.NotasForm['isEditable'],
		}),
	},
	methods: {
		clone(obj) {
			return JSON.parse(JSON.stringify(obj));
		},
		clearFields() {
			this.$store.state.teletrabajo.NotasForm['form'] =
				this.clone(defaultNotasForm);
		},
		closeForm() {
			this.$store.state.teletrabajo.NotasForm.isOpen = false;
		},
		save() {
			this.addNotas().then(() => {
				this.closeForm();
			});
		},
		getComercialNombreFromId(id) {
			if (typeof id == 'object') {
				id = id.id;
			}
			let comercial = this.comerciales.find((obj) => obj.id == id);
			return comercial?.nombreCompleto;
		},
		...mapActions('teletrabajo', {
			addNotas: 'addNotas',
		}),
	},
	watch: {
		comerciales: {
			immediate: true,
			handler: function () {
				let comercial = this.comerciales.find(
					({ id }) => id == this.$store.state.login.id
				);
				if (comercial) {
					this.form.comercial = comercial.id;
				}
			},
		},
	},
};
</script>
